import Insight from './insight'

import { InsightData } from '.'

export interface Data extends InsightData {
  nr_of_workspaces: number
}

class InsightTrend extends Insight<Data> {
  get name() {
    return this.data?.x
  }

  get numberOfWorkspaces() {
    return this.data.nr_of_workspaces
  }
}

export default InsightTrend
